import { PortalContext } from "App";
import { useContext } from "react";

/**
 * hook to simplify access to page state
 *
 * @param {Object} props
 * @param {String} props.pagePath The page path of the caller
 * @returns
 */
const usePageState = ({ pagePath }) => {
  const stateContext = useContext(PortalContext);
  const { detailPageState } = stateContext;

  const sessionState = JSON.parse(sessionStorage.getItem("state"));
  return detailPageState?.[pagePath] || sessionState?.[pagePath] || {};
};

export default usePageState;
